import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { KeywordQueryGq } from '../models/KeywordQueryGq';

export function useGetKeywordsKeywordsForCopyGq(
  command: CommandGq,
  options?: QueryHookOptions<ResponseGq, VariablesGq>
) {
  const query = useCustomQuery<ResponseGq, VariablesGq>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
    ...options,
  });

  return {
    query,
    keywords: (query?.data ?? query?.previousData)?.projects?.getKeywordsForCopy?.keywords,
  };
}

export const gqTag = gql`
  query ProjectsGetKeywordsForCopy($command: ProjectGetKeywordsForCopyCommand!) {
    projects {
      getKeywordsForCopy(command: $command) {
        currency
        currencyConversion
        keywords {
          id
          keyword
          volume
          cPC
          bidLow
          bidHigh
          competition
        }
      }
    }
  }
`;

export interface ResponseGq {
  projects?: {
    getKeywordsForCopy?: {
      keywords?: CopyKeywordGq[];
      currency: string;
      currencyConversion: number;
    };
  };
}

export interface CopyKeywordGq {
  id: number;
  keyword: string;
  volume: number;
  cPC: number;
  bidLow: number;
  bidHigh: number;
  competition: number;
}

export interface VariablesGq {
  command: CommandGq;
}
export interface CommandGq {
  keywordQuery: KeywordQueryGq;
}
